import clsx from 'clsx';
import { Circle } from './Circle';
import {
  FastForward,
  FastRewind,
  FiberManualRecord,
  Pause,
  PlayArrow,
  SkipNext,
  SkipPrevious,
  Stop,
} from '@material-ui/icons';
import { RemoteButton } from '../../../../hooks/useRemote';

interface Props {
  buttons: RemoteButton[];
  onClick(commandId: number): void;
}

export const Playback = ({ buttons, onClick }: Props) => {
  const classes = useStyles();
  const getButton = (position: number) =>
    buttons.find((button) => button.order === position);

  const handlePress = (position: number) => {
    const button = getButton(position);
    if (button === undefined) return undefined;
    return onClick(button.id);
  };

  const defaultProps: any = {
    className: 'mx-auto',
    size: 'lg',
  };

  return (
    <div className="col-span-full">
      <div
        className={clsx('grid grid-cols-4 grid-rows-2 w-full align-middle', {
          'gap-0': window.devicePixelRatio > 1,
          'gap-2': window.devicePixelRatio <= 1,
        })}
      >
        <Circle
          disabled={Boolean(getButton(1)) === false}
          onClick={() => handlePress(1)}
          onTouchEnd={() => handlePress(1)}
          {...defaultProps}
        >
          <FastRewind fontSize="small" />
        </Circle>
        <Circle
          disabled={Boolean(getButton(2)) === false}
          onClick={() => handlePress(2)}
          onTouchEnd={() => handlePress(2)}
          {...defaultProps}
        >
          <PlayArrow fontSize="small" />
        </Circle>
        <Circle
          disabled={Boolean(getButton(3)) === false}
          onClick={() => handlePress(3)}
          onTouchEnd={() => handlePress(3)}
          {...defaultProps}
        >
          <Pause fontSize="small" />
        </Circle>
        <Circle
          disabled={Boolean(getButton(4)) === false}
          onClick={() => handlePress(4)}
          onTouchEnd={() => handlePress(4)}
          {...defaultProps}
        >
          <FastForward fontSize="small" />
        </Circle>
        <Circle
          disabled={Boolean(getButton(5)) === false}
          onClick={() => handlePress(5)}
          onTouchEnd={() => handlePress(5)}
          {...defaultProps}
        >
          <SkipPrevious fontSize="small" />
        </Circle>
        <Circle
          disabled={Boolean(getButton(6)) === false}
          onClick={() => handlePress(6)}
          onTouchEnd={() => handlePress(6)}
          {...defaultProps}
        >
          <Stop fontSize="small" />
        </Circle>
        <Circle
          disabled={Boolean(getButton(7)) === false}
          onClick={() => handlePress(7)}
          onTouchEnd={() => handlePress(7)}
          {...defaultProps}
        >
          <FiberManualRecord fontSize="small" />
        </Circle>
        <Circle
          disabled={Boolean(getButton(8)) === false}
          onClick={() => handlePress(8)}
          onTouchEnd={() => handlePress(8)}
          {...defaultProps}
        >
          <SkipNext fontSize="small" />
        </Circle>
      </div>
    </div>
  );
};

const useStyles = () => ({});
